/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetFinancialTransactionQueryResponse, GetFinancialTransactionPathParams, GetFinancialTransaction400, GetFinancialTransaction401, GetFinancialTransaction403, GetFinancialTransaction404, GetFinancialTransaction409, GetFinancialTransaction500 } from "../../types/financialHubController/GetFinancialTransaction.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getFinancialTransaction } from "../../client/financialHubController/getFinancialTransaction.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getFinancialTransactionQueryKey = (organizationId: GetFinancialTransactionPathParams["organizationId"] | undefined, transactionId: GetFinancialTransactionPathParams["transactionId"] | undefined) => [{ url: '/api/organizations/:organizationId/financial/transactions/:transactionId', params: {organizationId:organizationId,transactionId:transactionId} }] as const

export type GetFinancialTransactionQueryKey = ReturnType<typeof getFinancialTransactionQueryKey>

export function getFinancialTransactionQueryOptions(organizationId: GetFinancialTransactionPathParams["organizationId"] | undefined, transactionId: GetFinancialTransactionPathParams["transactionId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFinancialTransactionQueryKey(organizationId, transactionId)
        return queryOptions<GetFinancialTransactionQueryResponse, ResponseErrorConfig<GetFinancialTransaction400 | GetFinancialTransaction401 | GetFinancialTransaction403 | GetFinancialTransaction404 | GetFinancialTransaction409 | GetFinancialTransaction500>, GetFinancialTransactionQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && transactionId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFinancialTransaction(organizationId!, transactionId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get ledger transaction detail
 * {@link /api/organizations/:organizationId/financial/transactions/:transactionId}
 */
export function useGetFinancialTransaction<TData = GetFinancialTransactionQueryResponse, TQueryData = GetFinancialTransactionQueryResponse, TQueryKey extends QueryKey = GetFinancialTransactionQueryKey>(organizationId: GetFinancialTransactionPathParams["organizationId"] | undefined, transactionId: GetFinancialTransactionPathParams["transactionId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetFinancialTransactionQueryResponse, ResponseErrorConfig<GetFinancialTransaction400 | GetFinancialTransaction401 | GetFinancialTransaction403 | GetFinancialTransaction404 | GetFinancialTransaction409 | GetFinancialTransaction500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getFinancialTransactionQueryKey(organizationId, transactionId)
         

         const query = useQuery({
          ...getFinancialTransactionQueryOptions(organizationId, transactionId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetFinancialTransaction400 | GetFinancialTransaction401 | GetFinancialTransaction403 | GetFinancialTransaction404 | GetFinancialTransaction409 | GetFinancialTransaction500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}